<mat-tab-group
  class="tab-group"
  [mat-stretch-tabs]="false"
  color="warn"
  libTabActivated
>
  <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.PayerHiddenTableComponent">
    <ng-template mat-tab-label class="mat-tab-label">
      <mat-icon [svgIcon]="EsvgFiles.money"/>
    </ng-template>

    <ng-template matTabContent>
      <app-payer-hidden-table/>
    </ng-template>
  </mat-tab>

  <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.DataofficeTableComponent">
    <ng-template mat-tab-label class="mat-tab-label">
      <mat-icon [svgIcon]="EsvgFiles.reset"/>
    </ng-template>

    <ng-template matTabContent>
      <app-dataoffice-table/>
    </ng-template>
  </mat-tab>

  <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.AlternativePayerTableComponent">
    <ng-template mat-tab-label class="mat-tab-label">
      <mat-icon [svgIcon]="EsvgFiles.alternative"/>
    </ng-template>

    <ng-template matTabContent>
      <app-alternative-table-payer/>
    </ng-template>
  </mat-tab>
</mat-tab-group>
